<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Activités de l'officine (2/4)">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <span class="subtitle-1 text-left font-weight-bold">
                Pharmacie clinique
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Proposez-vous des plans de posologie à certains patients
                ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.posologiePlan"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="posologiePlan"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="posologiePlan"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <p class="subtitle-1 text-left">
                &#187; Formalisez-vous votre conseil pharmaceutique ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.formalisationCP"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="formalisationCP"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="formalisationCP"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <p class="subtitle-1 text-left">
                &#187; Contribuez-vous aux vigilances ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.contributionVigilances"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="contributionVigilances"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="contributionVigilances"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; Disposez-vous d’une procédure de suivi de vos
                interventions pharmaceutiques ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.procedureIntervention"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="procedureIntervention"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="procedureIntervention"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.procedureIntervention">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.procedureInterventionPrecision"
                label="Si oui, sous quelle forme ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; Avez-vous la pratique occasionnelle ou régulière des
                entretiens pharmaceutiques ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.entretienPharmaceutique"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="entretienPharmaceutique"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="entretienPharmaceutique"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.entretienPharmaceutique">
            <v-col cols="12" md="8">
              <v-subheader>&#187; Si oui, lesquels : </v-subheader>
              <v-list-item-group
                v-model="entretiensPharmaModel"
                multiple
                active-class=""
              >
                <div
                  v-for="entretienPharma in entretiensPharma"
                  :key="entretienPharma"
                >
                  <v-list-item :value="entretienPharma">
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ entretienPharma }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                  <div v-if="entretienPharma == 'Autres'">
                    <v-text-field
                      class="autreEntretienPharma"
                      v-if="autresEntretiens"
                      v-model="dossier.entretienPharmaceutiquePrecisionAutre"
                      label="Si autres, précisez :"
                      required
                      :rules="textRules"
                    />
                  </div>
                </div>
              </v-list-item-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; Avez-vous la pratique occasionnelle ou régulière de la
                vaccination anti-grippale ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.vaccinationAntiGrippale"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="vaccinationAntiGrippale"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="vaccinationAntiGrippale"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; Réalisez-vous occasionnellement ou régulièrement des TROD
                ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.trod"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="trod"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="trod"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.trod">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.trodPrecision"
                label="Si oui, lesquels ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; L’espace de confidentialité présent dans l’officine
                est-il accessible depuis l’espace client ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.espaceConfidentialite"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="espaceConfidentialite"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="espaceConfidentialite"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; Le local dédié à l’orthopédie présent dans l’officine
                est-il accessible depuis l’espace client ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.localOrthopedie"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="localOrthopedie"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="localOrthopedie"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie9",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    entretiensPharma: [
      "Anticoagulants (AVK, AOD)",
      "Asthme",
      "Bilans partagés de médication",
      "Traitements anticancéreux par voie orale",
      "Autres"
    ],
    entretiensPharmaModel: [],
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"]
  }),
  created() {
    this.entretiensPharmaModel = JSON.parse(
      this.dossier.entretienPharmaceutiquePrecision
    );
    if (!this.entretiensPharmaModel) this.entretiensPharmaModel = [];
  },
  computed: {
    ctext: {
      get() {
        return this.cvalue;
      },
      set(value) {
        this.$emit("update:cvalue", value);
      }
    },
    autresEntretiens() {
      return this.entretiensPharmaModel.indexOf("Autres") > -1;
    }
  },
  methods: {
    async submit() {
      this.dossier.entretienPharmaceutiquePrecision = JSON.stringify(
        this.entretiensPharmaModel
      );
      if (this.$refs.form.validate()) {
        if (!this.dossier.procedureIntervention)
          this.dossier.procedureInterventionPrecision = null;
        if (!this.dossier.autresEntretiens)
          this.dossier.entretienPharmaceutiquePrecisionAutre = null;
        if (!this.dossier.trod) this.dossier.trodPrecision = null;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
<style scoped>
.autreEntretienPharma {
  margin-left: 30px !important;
}
</style>
